import { useInfiniteQuery } from "@tanstack/react-query";
import { MessageInfo } from "@42maru/webchat";
import { emptyPage } from "@/model";
import conversationRepository from "@/repository/conversationRepository";


interface UsePaginatedConversationMessagesProps {
    scenarioId: string;
    conversationId: string;
    sort?: string;
    page?: number;
    size: number;
}

const getData = async (scenarioId: string, conversationId: string, page: number, size: number, sort?: string) => {
    const res = await conversationRepository.findMessages(scenarioId, conversationId, page, size, sort);
    return res.data || emptyPage<MessageInfo>();
};

export const usePaginatedConversationMessages = ({
    scenarioId,
    conversationId,
    sort = "desc",
    page = 0,
    size
}: UsePaginatedConversationMessagesProps) => {
    const initialParam = { page, size };

    return useInfiniteQuery({
        queryKey: ["messages", "paginated", scenarioId, conversationId, page, size, sort],
        queryFn: ({ pageParam = initialParam }) =>
            getData(
                scenarioId,
                conversationId,
                pageParam.page as number,
                pageParam.size as number,
                sort
            ),
        initialPageParam: initialParam,
        getNextPageParam: (lastPage) => {
            if (!lastPage?.has_next) {
                return undefined;
            }
            return {
                page: lastPage.page + 1,
                size: lastPage.size
            };
        },
        getPreviousPageParam: (firstPage) => {
            if (!firstPage?.has_previous) {
                return undefined;
            }
            return {
                page: firstPage.page - 1,
                size: firstPage.size
            };
        },
        enabled: false,
    });
}; 